export const ESSENTIALS_GET_MEDIA_ARTICLES = `query getArticle($slug: [String], $site: [String]) {
  entry(section: "articles", slug: $slug, site: $site) {
    ...article
    blocks {
      ...blocks
    }
  }
}

fragment article on articles_articles_Entry {
  ...articleBaseProps
}

fragment image on AssetInterface {
  id
  width
  height
  title
  mimeType
  focalPoint
  path
  url
}

fragment baseProps on EntryInterface {
  id
  uri
  slug
  title
}

fragment articleBaseProps on EntryInterface {
  ...baseProps
  readTime: text
  listingExcerpt: text2
  image {
    ...image
  }
  animationImages {
    animated {
      ...image
    }
    still {
      ...image
    }
  }
  contentFormat
  contentType
  tag
}

fragment blocks on NeoBlockInterface {
  ... on blocks_articleMarquee_BlockType {
    vimeoId
    vimeoId2
  }
  ... on blocks_audio_BlockType {
    audio {
      url
      title
    }
    looping
    labels: textRepeater {
      text
    }
    attribution: fullWysiwyg
  }
  ... on blocks_copy_BlockType {
    body: fullWysiwyg
  }
  ... on blocks_accordion_BlockType {
    body: fullWysiwyg2
  }
}`
